export function isArrayOf(value, predicate) {
  return Array.isArray(value) && value.every(predicate);
}